
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground, PropsTable } from 'docz';
import { useState } from 'react';
import Badge from "../shared/components/Badge.js"
import Text from "../shared/components/Text.js"
import "../shared/css/index.css"

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"badge"}}>{`Badge`}</MDXTag>
<Playground __position={0} __code={'() => {\n  const types = [\'success\', \'danger\', \'warning\', \'info\']\n  const [type, setType] = useState(\'success\')\n\n  return (\n    <div>\n      <div>\n        <label>Type</label>\n        <select value={type} onChange={e => setType(e.target.value)}>\n          {types.map(typeVal => (\n            <option value={typeVal}>{typeVal}</option>\n          ))}\n        </select>\n      </div>\n      <Badge type={type}>\n        <Text>Este es un badge</Text>\n      </Badge>\n    </div>\n  )\n}'} __scope={{props: this ? this.props : props,useState,Badge,Text}}>
  {() => {
    const types = ['success', 'danger', 'warning', 'info'];
const [type, setType] = useState('success');

return (
  <div>
    <div>
      <label>Type</label>
      <select value={type} onChange={(e) => setType(e.target.value)}>
        {types.map(typeVal => <option value={typeVal}>{typeVal}</option>)}
      </select>
    </div>
    <Badge type={type}>
      <Text>Este es un badge</Text>
    </Badge>
  </div>
)
  }}
</Playground>
<PropsTable of={Badge} />
           </MDXTag>
  }
}
  